import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';
import * as bootstrap from 'bootstrap';

export default class InvestFormController extends Controller {
  static targets = [
    'subscriptionAmount',
    'feesAmount',
    'fieldsErrors',
    'subscriptionAmountDivs',
    'feesAmountDivs',
    'totalAmountDivs',
    'modalTotalWithFees',
    'submitButton',
    'insufficientBalance',
    'subscribeModal',
  ];

  static values = {
    feesUrl: String,
    projectId: String,
    profileBalance: Number,
    max_invest_recommendation: Number,
    user_may_have_warning: Boolean,
  };

  // Compute fees and total through backend
  computeFeesAndTotal() {
    const amount = this.subscriptionAmountTarget.value;
    let controller = this;

    Rails.ajax({
      type: 'GET',
      url: this.feesUrlValue,
      data: 'amount=' + amount + '&project_id=' + this.projectIdValue,
      dataType: 'json',
      success: function (response) {
        const feesAmount = parseFloat(response['fees_amount']);
        const totalWithFeesAmount = parseFloat(response['total_with_fees']);

        // Check if the amount is valid
        controller.checkAmountValidity(amount, totalWithFeesAmount);

        // Display fees and total
        controller.feesAmountTarget.value = feesAmount;
        controller.subscriptionAmountDivsTargets.innerHTML =
          controller.updateAmounts(
            controller.subscriptionAmountDivsTargets,
            parseFloat(amount)
          );
        controller.feesAmountDivsTargets.innerHTML = controller.updateAmounts(
          controller.feesAmountDivsTargets,
          feesAmount
        );
        controller.totalAmountDivsTargets.innerHTML = controller.updateAmounts(
          controller.totalAmountDivsTargets,
          totalWithFeesAmount
        );
        controller.modalTotalWithFeesTarget.innerHTML =
          Helpers.numberToCurrency(totalWithFeesAmount, 2);
      },
      error: function () {
        controller.fieldsErrorsTarget.innerHTML =
          'Une erreur s\'est produite, veuillez réessayer.';
      },
    });
  }

  checkAmountValidity(amount, totalWithFeesAmount) {
    this.insufficientBalanceTarget.classList.add('d-none');

    const profileBalance = parseFloat(this.profileBalanceValue);

    switch (true) {
      case !this.subscriptionAmountTarget.checkValidity():
        this.fieldsErrorsTarget.innerHTML =
          this.subscriptionAmountTarget.validationMessage;
        return this.triggerError();
      case amount === '':

        this.fieldsErrorsTarget.innerHTML =
          'Un montant de souscription doit être renseigné.';
        return this.triggerError();
      case totalWithFeesAmount > profileBalance:
        this.insufficientBalanceTarget.classList.remove('d-none');
        this.fieldsErrorsTarget.innerHTML = '';
        return this.triggerError();
      default:
        this.submitButtonTarget.classList.remove('disabled');
        this.fieldsErrorsTarget.innerHTML = '';
        this.subscriptionAmountTarget.classList.remove('is-invalid');
        return true;
    }
  }

  updateAmounts(container, amount) {
    const finalAmount =
      amount === 0 || isNaN(amount)
        ? 'CHF-,--'
        : Helpers.numberToCurrency(amount, 2);

    container.forEach((element) => {
      element.innerHTML = finalAmount;
    });
  }

  triggerError() {
    this.submitButtonTarget.classList.add('disabled');
    this.subscriptionAmountTarget.classList.add('is-invalid');
    return false;
  }

  validateAndShowSubscriptionModal() {
    const amount = this.subscriptionAmountTarget.value;
    const maxInvestRecommendation = this.maxInvestRecommendationValue;
    const totalWithFeesAmount =
      parseFloat(amount) + parseFloat(this.feesAmountTarget.value);

    if (!this.checkAmountValidity(amount, totalWithFeesAmount)) return;

    this.showModal(this.subscribeModalTarget);
  }

  preventAutoSubmit(event) {
    event.preventDefault();
    this.validateAndShowSubscriptionModal();
  }

  showModal(modalTarget) {
    const modal = new bootstrap.Modal(modalTarget);
    modal.show();
  }
}
